import {
  BenefitsList,
  Hero,
  CallToActionButtons,
  BenefitExplanation,
  FunctionalityDemonstration,
  HeroCallToAction,
  Timeline,
  StartBooking,
  CostBreakdown,
} from "./Slices";

export const landingPageV2Slices = {
  hero: Hero,
  benefitslist: BenefitsList,
  calltoactionbuttons: CallToActionButtons,
  benefitexplanation: BenefitExplanation,
  functionalitydemonstration: FunctionalityDemonstration,
  herocalltoaction: HeroCallToAction,
  timeline: Timeline,
  startbooking: StartBooking,
  cost_breakdown: CostBreakdown,
};
